export default __webpack_public_path__ + "static/media/img9.9b567925.png";